/**
 * Created with IntelliJ IDEA.
 * User: raml
 * Date: 3/21/13
 * Time: 10:32 PM
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var LEResourceResolver = require("leResourceResolver");
    var SSOModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        SSOModel = BaseModel.extend({
            resource:LEResourceResolver.apiResources.SSOService,
            name: "SSOModel"

        });
    });
    return SSOModel;
});
